import { Module } from "wrapper6";

var $ = jQuery;

export default class Shop extends Module {

	ready(app) {

		if($('#buy-button').length){

			$(document).on('click', '#buy-button', function(e){

				e.preventDefault();

				$('.modalOverlay').show();
				$('.modal-container').css('display', 'flex');
				$('.modal-shop').css('display', 'flex');

				setTimeout(function(){

					$('.modalOverlay').css('opacity', '1');

					$('.modal-shop').css('transform', 'scale(1)');
					$('.modal-shop').css('opacity', '1');

				},10);

			});

			$(document).on('click', '.modalOverlay', function(){

				$('.modal-shop').css('transform', 'scale(0.3)');
				$('.modal-shop').css('opacity', '0');

				$('.modalOverlay').css('opacity', '0');

				setTimeout(function(){

					$('.modalOverlay').hide();
					$('.modal-shop').hide();
					$('.modal-container').hide();

				},400);

			});

			$(document).on('click', '.close', function(){

				$('.modal-shop').css('transform', 'scale(0.3)');
				$('.modal-shop').css('opacity', '0');

				$('.modalOverlay').css('opacity', '0');

				setTimeout(function(){

					$('.modalOverlay').hide();
					$('.modal-shop').hide();
					$('.modal-container').hide();

				},400);

			});

		}

    }
}